export const locKeys = {
  flightAllDealsText: "flights.allDeals.text",
  flightRoundTripText: "flights.roundTrip.text",
  flightOneWayText: "flights.oneWay.text",
  flightJustFoundText: "flights.justFound.text",
  flightHoursAgoText: "flights.foundHoursAgo.text",
  flightDaysAgoText: "flights.foundDaysAgo.text",
  flightAirportsWithAirline: "flights.airportsWithAirline",
  flightFindDealsFrom: "flights.findDealsFrom",
  flightFilteredMonth: "flights.filteredMonth.",
  flightFareTableOrigin: "flights.fareTable.Origin",
  flightFareTableDestination: "flights.fareTable.Destination",
  flightFareTableTravelDates: "flights.fareTable.TravelDates",
  flightFareTableFlightsFrom: "flights.fareTable.FlightsFrom",
  flightFareTableDisclaimer: "flights.fareTable.disclaimer",
  flightBarChartTooltip: "flights.barchart.tooltip",
  flightBarChartButtonNext: "flights.barchart.next",
  flightBarChartButtonPrev: "flights.barchart.prev",
  flightAccessibilityTravelDates: "flights.accessibility.travelDates",
  flightAccessibilityMessageOneWay: "flights.accessibility.message.oneWay",
  flightAccessibilityMessageRoundTrip: "flights.accessibility.message.roundTrip",
};
